"use client"

import styled from "@emotion/styled"
import { extractProperty, replaceRichTextLinks } from "utils"
import PortContainer from "./PortContainer"

const StyledSection = styled.section`
  --p-bg: ${(props) => props.theme.colors.port.lightBackgroundColor};
  --p-text: ${(props) => props.theme.colors.port.lightTextColor};
  padding-block: 40px;

  background-color: var(--p-bg);
  color: var(--p-text);
`

const StyledText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  text-align: unset;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 16px;
  }
  a {
    color: inherit;
  }
  > * {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`

type PortLegalTextProps = {
  data: any
}
const PortLegalText = ({ data }: PortLegalTextProps) => {
  const text = extractProperty(data, "text")

  // in case data fields are empty, return null
  if (!text) {
    return null
  }

  return (
    <StyledSection>
      <PortContainer paddingInline={20}>
        <StyledText dangerouslySetInnerHTML={{ __html: replaceRichTextLinks(text) }} />
      </PortContainer>
    </StyledSection>
  )
}
export default PortLegalText
